import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

class ScenariosList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.scenariosShow(id)}>{value}</Link>,
            },
            {
                Header: "Описание",
                accessor: "description",
                filterable: true,
            },
            {
                Header: "PropertyName",
                accessor: "externalData.propertyName",
                filterable: false,
                Cell: ({ value }) => value || "—",
            },
        ];
    }

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };
}

export default tableContainer(ScenariosList, "scenarios");
